.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1.6rem;
  background-color: var(--color-grayscale-tuna);
  border-radius: 0.4rem 0.4rem 0 0;
}

.title {
  line-height: 3.2rem;
  font-size: 1.6rem;
  font-weight: 700;
}

.table-container {
  padding: 0 1.6rem;
  background-color: var(--color-grayscale-shark);

  & > * {
    [data-collapsible-trigger] {
      padding: 1.6rem 0;
    }

    [data-collapsible-content] {
      padding: 0.8rem 0 1.6rem;
    }

    &:not(:last-child) {
      border-bottom: 0.1rem solid var(--color-grayscale-trout);
    }
  }
}

.row-title {
  font-size: 1.4rem;
  line-height: 1.7rem;
  font-weight: 500;
  color: var(--color-grayscale-anti-flash-white);
}

.row-subtitle {
  font-size: 1.4rem;
  line-height: 1.7rem;
  font-weight: 400;
  color: var(--color-grayscale-manatee);
}

.row-header {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  &[data-hidden='true'] {
    .row-title,
    .row-subtitle {
      color: var(--color-grayscale-trout);
    }
  }
}

.vertical-cell {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.horizontal-cell {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.cell-label {
  color: var(--color-grayscale-light-slate);
  font-size: 1.2rem;
  font-weight: 400;
}

.cell-content {
  color: var(--color-grayscale-white);
  font-size: 1.2rem;
  font-weight: 400;
}

.row-container {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  &[data-hidden='true'] {
    .cell-content {
      color: var(--color-grayscale-trout);
    }
  }
}
